import React, { memo } from 'react';

function FieldsIcon({ color = '#788590', ...props }) {
    return (
        <svg viewBox="0 0 24 24" {...props}>
            <title>Icons/Actions/ic_fields</title>
            <path
                d="M19.619 11.524H18.19v-3.81a1.904 1.904 0 00-1.904-1.904h-3.81V4.38a2.381 2.381 0 00-4.762 0V5.81h-3.81A1.905 1.905 0 002 7.714v3.62h1.429A2.56 2.56 0 016 13.903a2.56 2.56 0 01-2.571 2.572H2v3.62C2 21.146 2.853 22 3.905 22h3.619v-1.429A2.56 2.56 0 0110.095 18a2.56 2.56 0 012.572 2.571V22h3.619a1.905 1.905 0 001.904-1.905v-3.81h1.429a2.381 2.381 0 000-4.761z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    );
}

export default memo(FieldsIcon);
